import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'

import Home from '../views/Home.vue'
import CreateAccount from '../views/CreateAccount.vue'
import Dashboard from '../views/Dashboard.vue'
// import CreateAdmin from '../views/CreateAdmin.vue'
// import Reset from '../views/Reset.vue'
import Training from '../views/Training.vue'
// import BatchRegistration from '../views/BatchRegistration.vue'
import TrainingRegistration from '../views/TrainingRegistration.vue'
// import BatchAddTrainingSessions from '../views/BatchAddTrainingSessions.vue'
import Report from '../views/Report.vue'

Vue.use(VueRouter)

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home,
          meta: {
            requiresAuth: false
          }
      },
      {
        path: '/create-account',
        name: 'create-account',
        component: CreateAccount,
          meta: {
            requiresAuth: false
          }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
          meta: {
            requiresAuth: true
          }
      },
      // {
      //   path: '/create-admin',
      //   name: 'create-admin',
      //   component: CreateAdmin
      // },
      // {
      // path: '/reset',
      // name: 'reset',
      // component: Reset
      // },
      {
        path: '/training',
        name: 'training',
        component: Training,
          meta: {
            requiresAuth: false
          }
      },
      // {
      //   path: '/batch-registration',
      //   name: 'batch-registration',
      //   component: BatchRegistration,
      //     meta: {
      //       requiresAuth: true
      //     }
      // },
      {
        path: '/training-registration',
        name: 'training-registration',
        component: TrainingRegistration,
          meta: {
            requiresAuth: false
          }
      },
      {
        path: '/report',
        name: 'report',
        component: Report,
          meta: {
            requiresAuth: true
          }
      }
      // {
      //   path: '/batch-add-trainings',
      //   name: 'batch-add-training-sessions',
      //   component: BatchAddTrainingSessions
      // }
    ],
    scrollBehavior() {
      window.scrollTo(0,0)
    }
  })

  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser

    if (requiresAuth && !currentUser) {
      sessionStorage.setItem('redirectPath', to.path)
      next('/')
    } else {
      next()
    }
  })

  export default router



//   const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   }
// ]
//
// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
//
// export default router
